import React, { useEffect, useState } from 'react';
import { Box, List, ListItem, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

function RecordedByTitleStationsPage() {
  const [stations, setStations] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = '錄製節目';
    api.get('/stations')
      .then(res => setStations(res.data || []))
      .catch(err => console.error('無法取得電台清單:', err));
  }, []);

  return (
    <Box>
      <List>
        {stations.map(station => (
          <ListItem
            key={station.station_id}
            button
            onClick={() => navigate(`/recorded/stations/${station.station_id}`)}
          >
            <ListItemText
              primary={station.station_name || station.station_id}
              secondary={
                station.episode_count != null
                  ? `${station.series_count || 0} 個系列 · ${station.episode_count} 集`
                  : null
              }
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}

export default RecordedByTitleStationsPage;